/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';


export interface ClientTransactionDto { 
    id?: number;
    uuid?: string;
    created?: string;
    status?: ClientTransactionDto.StatusEnum;
    errorMessage?: string;
    points?: number;
    finishedAt?: string;
    title?: string;
    details?: string;
    company?: CompanyDto;
    invoiceNo?: string;
    invoiceDate?: string;
    invoiceTime?: string;
}
export namespace ClientTransactionDto {
    export type StatusEnum = 'INITIALIZED' | 'SUCCESS' | 'VALIDATION_PENDING' | 'ERROR' | 'DECLINED' | 'REPORTED';
    export const StatusEnum = {
        Initialized: 'INITIALIZED' as StatusEnum,
        Success: 'SUCCESS' as StatusEnum,
        ValidationPending: 'VALIDATION_PENDING' as StatusEnum,
        Error: 'ERROR' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum,
        Reported: 'REPORTED' as StatusEnum
    };
}


